import { render, staticRenderFns } from "./SOV.vue?vue&type=template&id=a247f6ac&scoped=true"
import script from "./SOV.vue?vue&type=script&lang=js"
export * from "./SOV.vue?vue&type=script&lang=js"
import style0 from "./SOV.vue?vue&type=style&index=0&id=a247f6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a247f6ac",
  null
  
)

export default component.exports